import { TextareaHTMLAttributes } from "react"
import './TextArea.less'

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>

const TextArea = ({className, ...props}: TextAreaProps): JSX.Element => (
  <textarea className={`hb-text-area ${className}`} {...props} />
)

export default TextArea
